module.exports = __webpack_public_path__ + "img/1557614062493310977.8fc7a63d.png";